import { useLocalStorage } from "us.helper";

// Define an interface for the return object of useLocalTemplate
type UseLocalTemplate = {
  saveLocalTemplate: (template: any) => void;
  getLocalTemplate: () => any | undefined;
  removeLocalTemplate: () => void;
};

/**
 * Custom hook to manage template data in localStorage.
 * @returns {Object} An object containing functions to save, get, and remove a template.
 */
const useLocalTemplate = (): UseLocalTemplate => {
  const { setItem, getItem, removeItem } = useLocalStorage(
    "@new-template-details"
  );

  /**
   * Saves a template to localStorage.
   * @param {any} template - The template data to be saved.
   */
  const saveLocalTemplate = (template: any) => {
    setItem(template);
  };

  /**
   * Retrieves a template from localStorage.
   * @returns {any | undefined} The retrieved template data or undefined if not found.
   */
  const getLocalTemplate = (): any | undefined => {
    return getItem();
  };

  /**
   * Removes a template from localStorage.
   */
  const removeLocalTemplate = () => {
    removeItem();
  };

  // Returns an object with saveTemplate, getTemplate, and removeTemplate functions
  return {
    saveLocalTemplate,
    getLocalTemplate,
    removeLocalTemplate,
  };
};

export default useLocalTemplate;
